// -──────────────────────────────────────────────────────────────────────────────
export const CATEGORIES = ['All', 'Sodas', 'Spreads & Creams', 'Chocolate', 'Baking', 'Whipped Cream'];

export const PRODUCTS = [
  // ─── IFRI Sodas (Available Now) ──────────────────────────────────────────
  {
    id: 1,
    brand: 'IFRI',
    name: 'Lemon',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'Bright and cleanly tart. Natural lemon flavour.',
    origin: 'Algeria',
    image: '/images/lemon.png',
    available: true,
    inStock: false,
  },
  {
    id: 2,
    brand: 'IFRI',
    name: 'Orange',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'Sun-ripened Algerian orange — vivid, naturally sweet, unforced.',
    origin: 'Algeria',
    image: '/images/orange.png',
    available: true,
    inStock: false,
  },
  {
    id: 3,
    brand: 'IFRI',
    name: 'Citrus',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'A layered citrus blend — bright, complex, softly effervescent.',
    origin: 'Algeria',
    image: '/images/citrus.png',
    available: true,
    inStock: false,
  },
  {
    id: 4,
    brand: 'IFRI',
    name: 'Pineapple',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'Tropical and full-bodied. Ripe pineapple character.',
    origin: 'Algeria',
    image: '/images/ananas.png',
    available: true,
    inStock: false,
  },
  {
    id: 5,
    brand: 'IFRI',
    name: 'Apple',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'Crisp and naturally sweet. Clean pressed-apple character in sparkling format.',
    origin: 'Algeria',
    image: '/images/apple.png',
    available: true,
    inStock: false,
  },
  {
    id: 6,
    brand: 'IFRI',
    name: 'Raspberry & Red Berries',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'Deep berry intensity — raspberry-forward with layered red fruit notes.',
    origin: 'Algeria',
    image: '/images/raspberry.png',
    available: true,
    inStock: false,
  },
  {
    id: 24,
    brand: 'IFRI',
    name: 'Green Apple',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'Tart and refreshing. Crisp green apple character with a clean effervescent finish.',
    origin: 'Algeria',
    image: '/images/green-apple.png',
    available: true,
    inStock: false,
  },
  {
    id: 25,
    brand: 'IFRI',
    name: 'Bitter',
    category: 'Sodas',
    itemsPerBox: 6,
    description: 'Classic Algerian bitter — aromatic citrus peel and botanical notes.',
    origin: 'Algeria',
    image: '/images/bitter.png',
    available: true,
    inStock: false,
  },

  // ─── El Mordjene — Spreads & Creams (Coming Soon) ────────────────────────
  {
    id: 7,
    brand: 'El Mordjene',
    name: 'Hazelnut & Cocoa Spread',
    size: '350g',
    itemsPerBox: 9,
    category: 'Spreads & Creams',
    description: 'Rich hazelnut and cocoa blend. Smooth, consistent texture for retail and food service.',
    origin: 'Algeria',
    image: '/images/creme-700g-noisette-cocoa.png',
    available: true,
    inStock: false
  },
  // {
  //   id: 8,
  //   brand: 'El Mordjene',
  //   name: 'Hazelnut & Cocoa Spread',
  //   size: '700g',
  //   category: 'Spreads & Creams',
  //   description: 'Rich hazelnut and cocoa blend. Smooth, consistent texture for retail and food service.',
  //   origin: 'Algeria',
  //   image: '/images/creme-700g-noisette-cocoa.png',
  //   available: true,
  //   inStock: true
  // },
  {
    id: 9,
    brand: 'El Mordjene',
    name: 'Hazelnut Cream',
    size: '350g',
    category: 'Spreads & Creams',
    description: 'Pure hazelnut cream — clean and delicate. Versatile for patisserie fillings and toppings.',
    origin: 'Algeria',
    image: '/images/creme-700g-noisette.png',
    itemsPerBox: 9,
    available: true,
    inStock: true
  },
  {
    id: 10,
    brand: 'El Mordjene',
    name: 'Hazelnut Cream',
    size: '700g',
    itemsPerBox: 6,
    category: 'Spreads & Creams',
    description: 'Pure hazelnut cream — clean and delicate. Versatile for patisserie fillings and toppings.',
    origin: 'Algeria',
    image: '/images/creme-700g-noisette.png',
    available: true,
    inStock: true
  },
  {
    id: 8,
    brand: 'El Mordjene',
    name: 'Hazelnut Cream with Grilled Hazelnut Chips',
    size: '200g',
    itemsPerBox: 12,
    category: 'Spreads & Creams',
    description: 'Smooth hazelnut cream with whole grilled hazelnut chips. Textured finish for decoration.',
    origin: 'Algeria',
    image: '/images/creme-noisettes-rocher-200g.png',
    available: true,
    inStock: false
  },
  {
    id: 11,
    brand: 'El Mordjene',
    name: 'Hazelnut Cream with Grilled Hazelnut Chips',
    size: '600g',
    itemsPerBox: 6,
    category: 'Spreads & Creams',
    description: 'Smooth hazelnut cream with whole grilled hazelnut chips. Textured finish for decoration.',
    origin: 'Algeria',
    image: '/images/rocher_bueno.png',
    available: true,
    inStock: true
  },
  {
    id: 12,
    brand: 'El Mordjene',
    name: 'Hazelnut & Cocoa Spread with Roasted Hazelnut Chips',
    size: '600g',
    itemsPerBox: 6,
    category: 'Spreads & Creams',
    description: 'Cocoa-forward spread with roasted hazelnut chip inclusions. Retail and confectionery grade.',
    origin: 'Algeria',
    image: '/images/rocher.png',
    available: true,
    inStock: true
  },

  // ─── El Mordjene — Chocolate (Coming Soon) ───────────────────────────────
  {
    id: 13,
    brand: 'El Mordjene',
    name: 'Milk Chocolate Substitute',
    size: '250g',
    itemsPerBox: 16,
    category: 'Chocolate',
    description: 'Professional-grade milk chocolate substitute. Consistent melt and enrobing properties.',
    origin: 'Algeria',
    image: '/images/glacage-au-lait.png',
    available: true,
    inStock: true
  },
  {
    id: 14,
    brand: 'El Mordjene',
    name: 'Dark Chocolate Substitute',
    category: 'Chocolate',
    itemsPerBox: 16,
    description: 'Bold cocoa character. Suitable for moulding, coating, and decorative confectionery work.',
    origin: 'Algeria',
    image: '/images/Glacagenoir.png',
    available: true,
    inStock: false
  },
  {
    id: 15,
    brand: 'El Mordjene',
    name: 'White Chocolate Substitute',
    category: 'Chocolate',
    itemsPerBox: 16,
    description: 'Smooth white chocolate substitute for coating, ganache, and decoration applications.',
    origin: 'Algeria',
    image: '/images/Glacage-blanc.png',
    available: true,
    inStock: true
  },

  // ─── El Mordjene — Baking (Coming Soon) ──────────────────────────────────
  {
    id: 16,
    brand: 'El Mordjene',
    name: 'Ghee',
    size: '900g',
    itemsPerBox: 8,
    category: 'Baking',
    description: 'Clarified vegetable fat. High smoke point, neutral finish. Suitable for all baking applications.',
    origin: 'Algeria',
    image: '/images/ghee-900g.png',
    available: true,
    inStock: true
  },
  {
    id: 17,
    brand: 'El Mordjene',
    name: 'Assila — Inverted Sugar',
    size: '1kg',
    itemsPerBox: 12,
    category: 'Baking',
    description: 'Inverted sugar syrup. Retards crystallisation and extends shelf life in baked goods.',
    origin: 'Algeria',
    image: '/images/assila-1kg.png',
    available: true,
    inStock: true
  },
  {
    id: 18,
    brand: 'El Mordjene',
    name: 'Icing Sugar',
    size: '700g',
    itemsPerBox: 12,
    category: 'Baking',
    description: 'Fine-milled powdered sugar. Consistent grind for glazes, buttercreams, and dusting.',
    origin: 'Algeria',
    image: '/images/Sucre-glace-paquet-700g.png',
    available: true,
    inStock: true
  },
  {
    id: 19,
    brand: 'El Mordjene',
    name: 'Corn Starch',
    size: '500g',
    itemsPerBox: 6,
    category: 'Baking',
    description: 'Pure corn starch. Reliable thickening agent for creams, custards, and sauces.',
    origin: 'Algeria',
    image: '/images/Maizena-paquet-500g.png',
    available: true,
    inStock: true
  },
  {
    id: 20,
    brand: 'El Mordjene',
    name: 'Baking Powder',
    size: '300g',
    itemsPerBox: 12,
    category: 'Baking',
    description: 'Consistent leavening action. Suitable for cakes, pastries, and all baked confectionery.',
    origin: 'Algeria',
    image: '/images/baking-powder-300g.png',
    available: true,
    inStock: true
  },
  {
    id: 21,
    brand: 'El Mordjene',
    name: 'Vanilla',
    size: '200g',
    itemsPerBox: 12,
    category: 'Baking',
    description: 'Pure vanilla flavouring. Natural-profile aroma for patisserie and confectionery.',
    origin: 'Algeria',
    image: '/images/Vanille-200g.png',
    available: true,
    inStock: true
  },

  // ─── El Mordjene — Whipped Cream (Coming Soon) ───────────────────────────
  {
    id: 22,
    brand: 'El Mordjene',
    name: 'Powdered Whipped Cream',
    size: '200g',
    itemsPerBox: 12,
    category: 'Whipped Cream',
    description: 'Professional-grade powdered whipping cream. Stable peaks, consistent volume.',
    origin: 'Algeria',
    image: '/images/Chantilly-200g.png',
    available: true,
    inStock: true
  },
  {
    id: 23,
    brand: 'El Mordjene',
    name: 'Powdered Whipped Cream',
    size: '600g',
    itemsPerBox: 6,
    category: 'Whipped Cream',
    description: 'Professional-grade powdered whipping cream. Stable peaks, consistent volume.',
    origin: 'Algeria',
    image: '/images/Chantilly-paquet-600g.png',
    available: true,
    inStock: true
  },
];
